/**
 * Waitlist Modal JavaScript - FIXED VERSION
 * This file: assets/waitlist-modal.js
 * Properly submits data to Shopify and captures customers
 */

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    duplicateCheckStorage: 'waitlist_submissions',
    successMessage: '🎉 Welcome to the Waitlist!\n\nThank you for joining! You\'ll receive a confirmation email shortly with all the details about your exclusive EARLYBIRD20 discount code.\n\n✨ Kindly check the spam folder and move us to your contacts/inbox to ensure you don\'t miss our launch notification!',
    duplicateMessage: '💝 I know you can\'t wait, love your enthusiasm!\n\nYou are already on the waitlist. If you haven\'t received the email, kindly check the spam folder and move us to your inbox.',
    errorMessage: '❌ Oops! Something went wrong.\n\nPlease try again or contact us at admin@karee.co.uk if the problem persists.'
  };

  // State
  let currentProduct = null;

  // Initialize on DOM load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    setupEventListeners();
    createHiddenSubmissionForm();
  }

  function createHiddenSubmissionForm() {
    // Create a hidden form that will actually submit to Shopify
    if (document.getElementById('waitlist-hidden-form')) {
      return; // Already exists
    }

    const hiddenForm = document.createElement('form');
    hiddenForm.id = 'waitlist-hidden-form';
    hiddenForm.method = 'POST';
    hiddenForm.action = '/contact#contact_form';
    hiddenForm.style.display = 'none';
    hiddenForm.acceptCharset = 'UTF-8';

    // Add required hidden fields
    hiddenForm.innerHTML = `
      <input type="hidden" name="form_type" value="contact">
      <input type="hidden" name="utf8" value="✓">
      <input type="hidden" name="contact[name]" id="hidden-name">
      <input type="hidden" name="contact[email]" id="hidden-email">
      <input type="hidden" name="contact[phone]" id="hidden-phone">
      <input type="hidden" name="contact[body]" id="hidden-body">
    `;

    document.body.appendChild(hiddenForm);
  }

  function setupEventListeners() {
    // Listen for clicks on waitlist buttons
    document.addEventListener('click', function(e) {
      const waitlistBtn = e.target.closest('.product-waitlist-btn');
      if (waitlistBtn) {
        e.preventDefault();
        openModal(waitlistBtn);
      }
    });

    // Close modal listeners
    const closeBtn = document.querySelector('.waitlist-modal-close');
    const overlay = document.getElementById('waitlist-modal-overlay');
    
    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }

    if (overlay) {
      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) {
          closeModal();
        }
      });
    }

    // ESC key to close
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        closeModal();
      }
    });

    // Form submission
    const form = document.getElementById('waitlist-form');
    if (form) {
      form.addEventListener('submit', handleFormSubmit);
    }
  }

  function openModal(button) {
    const productId = button.getAttribute('data-product-id');
    const productHandle = button.getAttribute('data-product-handle');
    const productTitle = button.getAttribute('data-product-title');
    const productImage = button.getAttribute('data-product-image');
    const productPrice = button.getAttribute('data-product-price');

    currentProduct = {
      id: productId,
      handle: productHandle,
      title: productTitle,
      image: productImage,
      price: productPrice
    };

    // Populate modal content
    document.getElementById('waitlist-modal-image').src = productImage;
    document.getElementById('waitlist-modal-image').alt = productTitle;
    document.getElementById('waitlist-modal-title').textContent = productTitle;
    document.getElementById('waitlist-modal-price').textContent = productPrice;

    // Set hidden form fields
    document.getElementById('waitlist-product-id').value = productId;
    document.getElementById('waitlist-product-handle').value = productHandle;
    document.getElementById('waitlist-product-name').value = productTitle;

    // Load product variants/sizes
    loadProductSizes(productHandle);

    // Show modal
    const overlay = document.getElementById('waitlist-modal-overlay');
    if (overlay) {
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    // Reset form
    resetForm();
  }

  function closeModal() {
    const overlay = document.getElementById('waitlist-modal-overlay');
    if (overlay) {
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    }
    
    // Reset form after animation
    setTimeout(resetForm, 300);
  }

  function resetForm() {
    const form = document.getElementById('waitlist-form');
    if (form) {
      form.reset();
    }
    
    hideMessage('waitlist-error-message');
    hideMessage('waitlist-success-message');
  }

  async function loadProductSizes(productHandle) {
    const sizeSelect = document.getElementById('waitlist-size');
    if (!sizeSelect) return;

    // Clear existing options except the first one
    sizeSelect.innerHTML = '<option value="">Choose Size</option>';

    try {
      const response = await fetch(`/products/${productHandle}.js`);
      const product = await response.json();

      if (product.variants && product.variants.length > 0) {
        product.variants.forEach(variant => {
          // Check if variant has a size option
          const size = variant.option1 || variant.option2 || variant.option3;
          
          if (size && size !== 'Default Title') {
            const option = document.createElement('option');
            option.value = size;
            option.textContent = size;
            
            // Optionally show if variant is sold out
            if (!variant.available) {
              option.textContent += ' (Sold Out)';
            }
            
            sizeSelect.appendChild(option);
          }
        });
      }

      // If no variants found, add a default option
      if (sizeSelect.options.length === 1) {
        const option = document.createElement('option');
        option.value = 'One Size';
        option.textContent = 'One Size';
        sizeSelect.appendChild(option);
      }
    } catch (error) {
      console.error('Error loading product sizes:', error);
      // Add a default option on error
      const option = document.createElement('option');
      option.value = 'One Size';
      option.textContent = 'One Size';
      sizeSelect.appendChild(option);
    }
  }

  async function handleFormSubmit(e) {
    e.preventDefault();

    // Hide previous messages
    hideMessage('waitlist-error-message');
    hideMessage('waitlist-success-message');

    // Validate form
    if (!validateForm()) {
      return;
    }

    // Get form data
    const formData = getFormData();

    // Check for duplicate submission
    if (isDuplicateSubmission(formData.email)) {
      showMessage('waitlist-success-message', CONFIG.duplicateMessage);
      return;
    }

    // Show loading state
    showLoading(true);

    try {
      // Submit to Shopify using hidden form
      const success = await submitToShopify(formData);

      if (success) {
        // Store submission
        storeSubmission(formData.email);
        
        // Show success message
        showMessage('waitlist-success-message', CONFIG.successMessage);
        
        // Reset form
        setTimeout(() => {
          document.getElementById('waitlist-form').reset();
        }, 1000);
        
        // Optionally close modal after delay
        // setTimeout(() => {
        //   closeModal();
        // }, 5000);
      } else {
        showMessage('waitlist-error-message', CONFIG.errorMessage);
      }
    } catch (error) {
      console.error('Submission error:', error);
      showMessage('waitlist-error-message', CONFIG.errorMessage);
    } finally {
      showLoading(false);
    }
  }

  function validateForm() {
    const requiredFields = [
      'waitlist-size',
      'waitlist-name',
      'waitlist-email',
      'waitlist-phone',
      'waitlist-city'
    ];

    const requiredCheckboxes = [
      'waitlist-email-consent',
      'waitlist-sms-consent',
      'waitlist-dpdp-consent'
    ];

    let isValid = true;

    // Validate required fields
    requiredFields.forEach(fieldId => {
      const field = document.getElementById(fieldId);
      if (field && !field.value.trim()) {
        field.classList.add('error');
        isValid = false;
      } else if (field) {
        field.classList.remove('error');
      }
    });

    // Validate checkboxes
    requiredCheckboxes.forEach(checkboxId => {
      const checkbox = document.getElementById(checkboxId);
      if (checkbox && !checkbox.checked) {
        checkbox.closest('.waitlist-checkbox-group').classList.add('error');
        isValid = false;
      } else if (checkbox) {
        checkbox.closest('.waitlist-checkbox-group').classList.remove('error');
      }
    });

    // Validate email format
    const emailField = document.getElementById('waitlist-email');
    if (emailField && emailField.value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(emailField.value)) {
        emailField.classList.add('error');
        showMessage('waitlist-error-message', 'Please enter a valid email address.');
        isValid = false;
      }
    }

    // Validate phone number (basic validation)
    const phoneField = document.getElementById('waitlist-phone');
    if (phoneField && phoneField.value) {
      const phoneRegex = /^[0-9\s\-\(\)]{8,}$/;
      if (!phoneRegex.test(phoneField.value)) {
        phoneField.classList.add('error');
        showMessage('waitlist-error-message', 'Please enter a valid phone number.');
        isValid = false;
      }
    }

    if (!isValid) {
      showMessage('waitlist-error-message', 'Please fill in all required fields correctly.');
    }

    return isValid;
  }

  function getFormData() {
    const countryCode = document.getElementById('waitlist-country-code').value;
    const phone = document.getElementById('waitlist-phone').value;
    const fullPhone = countryCode + phone.replace(/\s/g, '');

    return {
      product_id: document.getElementById('waitlist-product-id').value,
      product_handle: document.getElementById('waitlist-product-handle').value,
      product_name: document.getElementById('waitlist-product-name').value,
      size: document.getElementById('waitlist-size').value,
      full_name: document.getElementById('waitlist-name').value,
      email: document.getElementById('waitlist-email').value,
      phone: fullPhone,
      city: document.getElementById('waitlist-city').value,
      email_consent: document.getElementById('waitlist-email-consent').checked,
      sms_consent: document.getElementById('waitlist-sms-consent').checked,
      dpdp_consent: document.getElementById('waitlist-dpdp-consent').checked
    };
  }

  function submitToShopify(formData) {
    return new Promise((resolve, reject) => {
      // Create detailed message for Shopify
      const message = `
🎯 WAITLIST SIGNUP - KAREE CLOTHING
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

📦 PRODUCT INFORMATION:
Product Name: ${formData.product_name}
Product ID: ${formData.product_id}
Product Handle: ${formData.product_handle}
Selected Size: ${formData.size}

👤 CUSTOMER DETAILS:
Full Name: ${formData.full_name}
Email: ${formData.email}
Phone: ${formData.phone}
City: ${formData.city}

✅ CONSENT GRANTED:
Email Marketing: ${formData.email_consent ? 'YES ✓' : 'NO ✗'}
WhatsApp/SMS: ${formData.sms_consent ? 'YES ✓' : 'NO ✗'}
DPDP Act 2023: ${formData.dpdp_consent ? 'YES ✓' : 'NO ✗'}

🏷️ TAGS TO ADD: waitlist-member

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
Action Required:
1. Tag this customer with: waitlist-member
2. Add to "Waitlist Members" segment
3. Send welcome email with EARLYBIRD20 details
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
      `.trim();

      // Get the hidden form
      const hiddenForm = document.getElementById('waitlist-hidden-form');
      
      if (!hiddenForm) {
        console.error('Hidden form not found!');
        reject(new Error('Hidden form not found'));
        return;
      }

      // Populate hidden form fields
      document.getElementById('hidden-name').value = formData.full_name;
      document.getElementById('hidden-email').value = formData.email;
      document.getElementById('hidden-phone').value = formData.phone;
      document.getElementById('hidden-body').value = message;

      // Create iframe to submit form without page redirect
      const iframe = document.createElement('iframe');
      iframe.name = 'waitlist-submission-frame';
      iframe.style.display = 'none';
      document.body.appendChild(iframe);

      // Set form target to iframe
      hiddenForm.target = 'waitlist-submission-frame';

      // Listen for iframe load (submission complete)
      let submitted = false;
      iframe.onload = function() {
        if (!submitted) {
          submitted = true;
          // Clean up
          setTimeout(() => {
            document.body.removeChild(iframe);
          }, 1000);
          resolve(true);
        }
      };

      // Handle errors
      iframe.onerror = function() {
        console.error('Form submission failed');
        reject(new Error('Submission failed'));
      };

      // Submit the form
      try {
        hiddenForm.submit();
        
        // Fallback timeout in case iframe doesn't load
        setTimeout(() => {
          if (!submitted) {
            submitted = true;
            resolve(true);
          }
        }, 3000);
      } catch (error) {
        console.error('Form submission error:', error);
        reject(error);
      }
    });
  }

  function isDuplicateSubmission(email) {
    try {
      const submissions = JSON.parse(localStorage.getItem(CONFIG.duplicateCheckStorage) || '[]');
      return submissions.includes(email.toLowerCase());
    } catch (error) {
      console.error('Error checking duplicate:', error);
      return false;
    }
  }

  function storeSubmission(email) {
    try {
      const submissions = JSON.parse(localStorage.getItem(CONFIG.duplicateCheckStorage) || '[]');
      submissions.push(email.toLowerCase());
      localStorage.setItem(CONFIG.duplicateCheckStorage, JSON.stringify(submissions));
    } catch (error) {
      console.error('Error storing submission:', error);
    }
  }

  function showMessage(elementId, message) {
    const element = document.getElementById(elementId);
    if (element) {
      element.textContent = message;
      element.style.display = 'block';
      
      // Scroll to message
      element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function hideMessage(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
      element.style.display = 'none';
    }
  }

  function showLoading(show) {
    const loading = document.getElementById('waitlist-loading');
    const submitBtn = document.getElementById('waitlist-submit-btn');
    const form = document.getElementById('waitlist-form');

    if (loading) {
      loading.style.display = show ? 'block' : 'none';
    }

    if (submitBtn) {
      submitBtn.disabled = show;
      submitBtn.style.opacity = show ? '0.6' : '1';
    }

    if (form) {
      // Disable all form inputs while loading
      const inputs = form.querySelectorAll('input, select, button');
      inputs.forEach(input => {
        input.disabled = show;
      });
    }
  }

  // Export for potential external use
  window.WaitlistModal = {
    open: openModal,
    close: closeModal
  };

})();